import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const BlogDashboard = () => {

  const [blogs, setBlogs] = useState([]);

  const [form, setForm] = useState({
    title: "",
    content: "",
    section1: "",
    section2: "",
  });

  const [files, setFiles] = useState({
    image: null,
    sub_image1: null,
    sub_image2: null,
  });

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    const res = await fetch("/backend/blogs");
    const data = await res.json();
    setBlogs(data);
  };

  // ✅ HANDLE INPUT
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ HANDLE FILES
  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  // ✅ ADD BLOG
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("title", form.title);
    formData.append("content", form.content);
    formData.append("section1", form.section1);
    formData.append("section2", form.section2);

    formData.append("image", files.image);
    formData.append("sub_image1", files.sub_image1);
    formData.append("sub_image2", files.sub_image2);

    await fetch("/backend/blogs", {
      method: "POST",
      body: formData,
    });

    // RESET
    setForm({
      title: "",
      content: "",
      section1: "",
      section2: "",
    });

    setFiles({
      image: null,
      sub_image1: null,
      sub_image2: null,
    });

    fetchBlogs();
  };

  // ✅ DELETE BLOG
  const handleDelete = async (id) => {
    await fetch(`/backend/blogs/${id}`, {
      method: "DELETE",
    });

    setBlogs(blogs.filter((b) => b.id !== id));
  };

  return (
    <>
      <PageTitle activeMenu="Blogs" motherMenu="Dashboard" />

      <div className="row">

        {/* ================= ADD BLOG ================= */}
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4>Add Blog</h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>

                {/* MAIN IMAGE */}
                <label>Main Image</label>
                <input
                  type="file"
                  name="image"
                  className="form-control mb-3"
                  onChange={handleFileChange}
                  required
                />

                {/* TITLE */}
                <input
                  type="text"
                  name="title"
                  placeholder="Title"
                  className="form-control mb-3"
                  value={form.title}
                  onChange={handleChange}
                  required
                />

                {/* CONTENT */}
                <textarea
                  name="content"
                  className="form-control mb-3"
                  rows="4"
                  placeholder="Main Content"
                  value={form.content}
                  onChange={handleChange}
                  required
                ></textarea>

                {/* SECTION 1 */}
                <textarea
                  name="section1"
                  className="form-control mb-3"
                  rows="3"
                  placeholder="Section 1 (More Insights)"
                  value={form.section1}
                  onChange={handleChange}
                ></textarea>

                {/* SUB IMAGE 1 */}
                <label>Sub Image 1</label>
                <input
                  type="file"
                  name="sub_image1"
                  className="form-control mb-3"
                  onChange={handleFileChange}
                />

                {/* SUB IMAGE 2 */}
                <label>Sub Image 2</label>
                <input
                  type="file"
                  name="sub_image2"
                  className="form-control mb-3"
                  onChange={handleFileChange}
                />

                {/* SECTION 2 */}
                <textarea
                  name="section2"
                  className="form-control mb-3"
                  rows="3"
                  placeholder="Section 2 (Conclusion)"
                  value={form.section2}
                  onChange={handleChange}
                ></textarea>

                <button className="btn btn-primary">
                  Add Blog
                </button>

              </form>
            </div>
          </div>
        </div>

        {/* ================= BLOG LIST ================= */}
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4>All Blogs</h4>
            </div>

            <div className="card-body">
              <div className="row">

                {blogs.map((blog) => (
                  <div className="col-lg-4 mb-4" key={blog.id}>

                    <div className="card h-100">

                      {/* IMAGE */}
                      <img
                        src={`/backend${blog.image}`}
                        style={{ height: "200px", objectFit: "cover" }}
                        alt=""
                      />

                      <div className="card-body">

                        <h5>{blog.title}</h5>

                        <p style={{ fontSize: "13px", color: "#666" }}>
                          {blog.content?.substring(0, 80)}...
                        </p>

                        <button
                          onClick={() => handleDelete(blog.id)}
                          className="btn btn-danger btn-sm"
                        >
                          Delete
                        </button>

                      </div>

                    </div>

                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default BlogDashboard;